export const externalOAuthSignInErrorMessage = {
  id: 'is.external_oauth_callback.sign_in_error',
  defaultMessage:
    'There was an error during sign-in. Please try again. If the error persists, contact your ClinLife administrators.',
};
